/**
 * Returns the number of frames in a DICOM instance.
 * Enhanced MR objects may omit top-level NumberOfFrames (0028,0008) in WADO-RS
 * metadata while still providing PerFrameFunctionalGroupsSequence.
 */
export default function getNumberOfFrames(instance) {
  if (!instance) {
    return 1;
  }

  const numberOfFrames = Number(instance.NumberOfFrames);
  if (Number.isFinite(numberOfFrames) && numberOfFrames > 0) {
    return numberOfFrames;
  }

  const perFrameGroups = instance.PerFrameFunctionalGroupsSequence;
  if (Array.isArray(perFrameGroups) && perFrameGroups.length > 0) {
    return perFrameGroups.length;
  }

  return 1;
}

export function isMultiframeInstance(instance) {
  return getNumberOfFrames(instance) > 1;
}

/**
 * Ensures instance.NumberOfFrames is set when it can be inferred from functional groups.
 */
export function normalizeNumberOfFrames(instance) {
  if (!instance) {
    return instance;
  }

  const frames = getNumberOfFrames(instance);
  if (frames > 1) {
    instance.NumberOfFrames = frames;
  }

  return instance;
}
